const emojiNameRegex = /\[([a-zA-Z0-9\u4e00-\u9fa5]+)\]/g;
import emojiByName from './emojiMap';

function wrapBrackets(str: string) {
  return str.length > 0 ? '[' + str + ']' : '';
}

function wrapEmoji(str: string) {
  return str[0] !== ']' ? wrapBrackets(str) : str;
}

/**
 * @param {emoji} emoji name with format '[$name]' & in emojiMap.json
 * @return: image resource data_url format string or undefined if not found
 */
export const getEmojiResName = (emoji: string): string | undefined => {
  if (!emojiByName.hasOwnProperty(emoji)) {
    return undefined;
  }

  const code: number = emojiByName[emoji] as number;

  return `emoji-icon__${code}`;
};

/**
 * emojify a string (replace :emoji: with an emoji)
 * @param  {string} str
 * @param  {function} onMissing (gets emoji name with [] and returns a proper emoji if no emoji was found)
 * @param  {function} format (wrap the returned emoji in a custom element)
 * @return {string}
 */
export const emojify = (
  str: string,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onMissing: (s: string) => any,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  format: (text: string, source: string) => any,
): string => {
  if (!str) {
    return '';
  }

  return str
    .split(emojiNameRegex)
    .map((s: string, i: number) => {
      if (i % 2 === 0) {
        return s;
      }

      const emojiText = wrapEmoji(s);
      const emojiRes = getEmojiResName(emojiText);
      if (emojiRes === undefined && typeof onMissing === 'function') {
        return onMissing(s);
      }

      if (emojiRes !== undefined && typeof format === 'function') {
        return format(emojiText, emojiRes);
      }

      return emojiText;
    })
    .join('');
};

/**
 * return a random emoji
 * @return {key: key, emoji: emoji data url}
 */
export const random = (): {
  key: string;
  emoji: string | undefined;
} => {
  const emojiKeys = Object.keys(emojiByName);
  const randomIndex = Math.floor(Math.random() * emojiKeys.length);
  const key = emojiKeys[randomIndex];
  const emoji = getEmojiResName(key);
  return { key: key, emoji: emoji };
};

/**
 * get all emoji
 */
export const getAll = (): Array<{ [k: string]: string }> => {
  const res: Array<{ [k: string]: string }> = [];

  for (const [key, value] of Object.entries(emojiByName)) {
    res[(value as number) - 1] = {
      key,
      emoji: getEmojiResName(key) as string,
    };
  }
  return res;
};
